import { useSelector } from 'react-redux';
import { getSelectedTeamAccount, getMultiPortalSelectorOptions, } from '../../selectors/uiSelector';
export var useTeamAccountSelector = function () {
    var _a;
    var selectedTeamAccount = useSelector(getSelectedTeamAccount);
    var dropdownOptions = useSelector(getMultiPortalSelectorOptions);
    var nameOfSelectedTeamAccount = ((_a = dropdownOptions.find(function (_a) {
        var value = _a.value;
        return value === selectedTeamAccount;
    })) === null || _a === void 0 ? void 0 : _a.name) ||
        '';
    return {
        selectedTeamAccountId: selectedTeamAccount,
        selectedTeamAccountName: nameOfSelectedTeamAccount,
        dropdownOptions: dropdownOptions,
    };
};
